export const flex = {
    display: 'flex'
};
export const centered = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
export const between = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
};
export const jEnd = {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center'
};
export const rowCenter = {
    display: 'flex',
    justifyContent: 'center'
};
export const stack1_5 = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
};
export const colCenter = {
    display: 'flex',
    alignItems: 'center'
};
export const stack2 = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
};
export const centeredColumnStack = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
};
export const alignedLeftStack = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'flex-start'
};
export const centeredRowStack = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
};
export const stack2_5 = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
};
export const gridWraper = {
    boxShadow: '0px 8px 16px 0px #919EAB29',
    padding: '12px'
};
export const colEnd = {
    display: 'flex',
    alignItems: 'end'
};
export const filterButton = {
    background: '#919EAB14',
    color: 'black'
};
export const ellipsis = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
};
export const listItemLight = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: 'black'
};
export const listItemDark = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#212B36' // Changed from 'white' to match light variant text color
};
